export const availableIcons: string[] = [
  "icon-ada-accessible-parking",
  "icon-ada-accessible-storage-units",
  "icon-air-cooled-storage-units",
  "icon-alarmed-storage-units",
  "icon-automatic-monthly-payments",
  "icon-boat-storage",
  "icon-boxes-and-parking-supplies",
  "icon-bright-well-lit-property",
  "icon-business-storage",
  "icon-cash-accepted",
  "icon-checks-accepted",
  "icon-clean-bathrooms",
  "icon-climate-controlled-storage",
  "icon-commercial-storage",
  "icon-competitive-promotions",
  "icon-computer-controlled-gate-access",
  "icon-convenient-location",
  "icon-covered-vehicle-storage",
  "icon-daily-property-walks-and-audits",
  "icon-digital-surevillance-system",
  "icon-document-storage",
  "icon-drive-up-storage-units",
  "icon-elevators-available",
  "icon-fire-suppression-system",
  "icon-first-of-the-month-billing-cycle",
  "icon-free-reservations",
  "icon-fully-fenced-property",
  "icon-handcarts-available",
  "icon-heated-storage-units",
  "icon-high-security-diskus-locks-available",
  "icon-huge-selection-of-unit-sizes",
  "icon-indoor-loading-and-unloading-area",
  "icon-indoor-storage-units",
  "icon-indoor-vehicle-storage",
  "icon-lights-on-automatic-sensors",
  "icon-loading-and-unloading-area",
  "icon-mailboxes-for-rent",
  "icon-major-credit-cards-accepted",
  "icon-month-to-month-lease",
  "icon-motorcycle-storage",
  "icon-no-security-deposits",
  "icon-office-open-6-days-a-week",
  "icon-office-open-7-days-a-week",
  "icon-office-suites-for-rent",
  "icon-on-site-manager",
  "icon-pest-and-rodent-prevention",
  "icon-recieve-invoices-via-e-mail",
  "icon-recieve-invoices-via-usps",
  "icon-rv-storage",
  "icon-se-habla-espanol",
  "icon-secure-gate-access-system",
  "icon-secure-online-account-management",
  "icon-secure-online-payments",
  "icon-small-storage-lockers",
  "icon-snow-removal-service",
  "icon-storage-access-7-days-a-week",
  "icon-tenant-protection-plans-available",
  "icon-trained-storage-professionals",
  "icon-u-haul-truck-rentals",
  "icon-vehicle-storage",
  "icon-wide-driveway-aisles",
  "icon-wide-interior-hallways",
  "icon-wine-storage"
];
